import React, { createContext } from 'react';
import { logError } from '@/utils/usefulFuncs';

const defaultState = {
  highlightContextItem: null,
  onCitationClick: () => {
    logError('onCitationClick is not initialized');
    return null;
  },
  onCitationDismiss: () => {
    logError('onCitationDismiss is not initialized');
    return null;
  },
};

export const CitationsContext = createContext(defaultState);

export const CitationsContextProvider = ({ children }) => {
  const [highlightContextItem, setHighlightContextItem] = React.useState(null);

  const onCitationDismiss = () => {
    setHighlightContextItem(null);
  };
  const onCitationClick = (chunkId, doc, citationId) => {
    setHighlightContextItem({ chunkId, doc, citationId });
  };

  const value = React.useMemo(
    () => ({ highlightContextItem, onCitationClick, onCitationDismiss }),
    [highlightContextItem, onCitationClick, onCitationDismiss]
  );
  return <CitationsContext.Provider value={value}>{children}</CitationsContext.Provider>;
};
